import { initBotId } from "botid/client/core"
import { CONTACT_ENDPOINT } from "@/lib/data/contact"

let initialized = false

// Paths that should carry a Vercel BotID token when fetched from the browser.
// Each entry must match a Vercel-hosted server handler that calls checkBotId().
const PROTECTED_PATHS = [{ path: CONTACT_ENDPOINT, method: "POST" as const }]

export function ensureBotIdInitialized() {
  if (initialized) return
  if (typeof window === "undefined") return

  initialized = true
  initBotId({ protect: PROTECTED_PATHS })
}
